import { DashboardServiceTypeI, DashboardStatusI } from '@/modules/myServices/types/api/DashboardServices'

export const DASHBOARD_SERVICE_TYPES: DashboardServiceTypeI[] = ['vps', 'vpc', 'wordpress', 'ssl', 'domain']

export const SECTION_UNAVAILABLE = 'section_unavailable'

/**
 * Display labels for the service type keys `/services` groups by. Only the exceptions live here —
 * every other key reads correctly as its own uppercase (vps → VPS, domain → DOMAIN).
 */
export const SERVICE_TYPE_LABEL_EXCEPTIONS: Partial<Record<DashboardServiceTypeI, string>> = {
  ssl: 'SSL Certificates',
}

/** `vps` → "VPS", `ssl` → "SSL Certificates". Unknown keys fall back to their uppercase. */
export function getServiceTypeLabel(type: DashboardServiceTypeI | string): string {
  return SERVICE_TYPE_LABEL_EXCEPTIONS[type as DashboardServiceTypeI] ?? type.toUpperCase()
}
/**
 * What the dashboard's "Show cancelled services" switch hides when it is off. Sent as the
 * `excludeStatuses` filter, which the backend applies as a `where` clause, so an excluded
 * service is never read upstream and `meta.counts` is post-exclusion (`R-DASH-11`).
 *
 * `terminated` is in here because WHMCS splits one idea across two statuses: `Cancelled` is
 * where a service sits once its cancellation request is processed, and `Terminated` is where
 * most of them end up afterwards. The switch names the one the customer recognises and hides
 * both — leaving `terminated` out would make the switch look inert on a real account.
 */
export const CANCELLED_SERVICE_STATUSES: DashboardStatusI[] = ['cancelled', 'terminated']
